import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const MajorDepartmentApi = createApi({
  reducerPath: "MajorDepartmentApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start Major Department API's------------------------------------
    getAllMajorDepartmentData: builder.query({
      query: () => "get_all_major_departments",
      transformResponse: (response) => response.data,
    }),
    addMajorDepartment: builder.mutation({
      query: (addMajorDept) => ({
        url: "add_major_department",
        method: "POST",
        body: addMajorDept,
      }),
    }),

    editMajorDepartment: builder.mutation({
      query: (editMajorDept) => ({
        url: `edit_major_department`,
        method: "PUT",
        body: editMajorDept,
      }),
    }),
    getMajorDepartmentById: builder.query({
      query: ({ id }) => `get_single_major_department/${id}`,
      transformResponse: (response) => response?.data || [],
    }),

    deleteMajorDepartment: builder.mutation({
      query: (id) => ({
        url: `delete_major_department/${id}`,
        method: "DELETE",
      }),
    }),

    //END Major Department API's--------------------------------------------
  }),
});

export const {
  //major department api
  useGetAllMajorDepartmentDataQuery,
  useAddMajorDepartmentMutation,
  useEditMajorDepartmentMutation,
  useGetMajorDepartmentByIdQuery,
  useDeleteMajorDepartmentMutation,
} = MajorDepartmentApi;

export default MajorDepartmentApi;
